import { Injectable } from '@angular/core';
import { APP_CONFIG } from '../../../app.config';
import { UtilHelper } from '../../../shared/helpers/utils.helper';
import { Error } from '../../../shared/models/error.model';
import { RequestService } from '../../../shared/services/request.service';
import { BusinessHour } from '../../store/models/business-hour.model';
import { ChargeOption } from './enum/charge-option.enum';
import { ProductRegisterType } from './enum/product-register-type.enum';
import { ComplementOption } from './models/complement-options.model';
import { Complement } from './models/complement.model';
import { Product } from './models/product.model';

@Injectable()
export class ProductService {

	constructor(private requestService: RequestService) {
		console.log("constructor ProductService");
	}

	/**
	 * PRODUCTS
	 * =====================================
	 */

	getAll(category: number): Promise<Array<Product>> {
		return new Promise((resolve, reject) => {
			const url: string = APP_CONFIG.WEBSERVICE.PRODUCTS + '?categoryId=' + category;
			const urlRequest: string = this.requestService.buildUrlPathParams({ category: category }, url);

			this.requestService.getData(urlRequest).then((response: Array<Product>) => {
				const products: Array<Product> = new Array();
				if (response && response.length > 0) {
					response.forEach((p: any) => {
						products.push(new Product(p));
					});
				}
				console.log(products);
				resolve(products);
			}, (error: Error) => {
				console.log(error);
				reject(error);
			});
		});
	}

	save(product: Product): Promise<any> {
		return new Promise((resolve, reject) => {
			const data: any = JSON.parse(JSON.stringify(product.toJson()));
			this.requestService.postData(APP_CONFIG.WEBSERVICE.PRODUCTS, data, true).then((response: any) => {
				resolve(UtilHelper.getIdFromLocationPath(response.location));
			}, (error: Error) => {
				console.log(error);
				reject(error);
			});
		});
	}

	changeAllProductAvailability(item: any): Promise<any> {
		return new Promise((resolve, reject) => {
			const data: any = {
				categoryId: item.categoryId,
				localOrder: item.localOrder,
				delivery: item.delivery,
				takeaway: item.takeaway,
			};
			this.requestService.putData(APP_CONFIG.WEBSERVICE.CHANGE_ALL_PRODUCTS_MENU_AVAILABILITY, data).then((response: any) => {
				resolve(response);
			}, (error: Error) => {
				console.log(error);
				reject(error);
			});
		});
	}

	changeProductAvailability(product: Product): Promise<any> {
		return new Promise((resolve, reject) => {
			const data: any = {
				productId: product.id,
				localOrder: product.localOrder,
				delivery: product.delivery,
				takeaway: product.takeaway
			};
			this.requestService.putData(APP_CONFIG.WEBSERVICE.CHANGE_MENU_AVAILABILITY, data).then((response: any) => {
				resolve(response);
			}, (error: Error) => {
				console.log(error);
				reject(error);
			});
		});
	}

	duplicate(productId: number): Promise<any> {
		return new Promise((resolve, reject) => {
			this.requestService.postData(APP_CONFIG.WEBSERVICE.PRODUCTS_DUPLICATE + '/' + productId).then((response: any) => {
				resolve(response);
			}, (error: Error) => {
				console.log(error);
				reject(error);
			});
		});
	}

	remove(productId: number): Promise<any> {
		return new Promise((resolve, reject) => {
			const url: string = APP_CONFIG.WEBSERVICE.PRODUCTS + '/' + productId;
			this.requestService.deleteData(url).then((response: any) => {
				resolve(response);
			}, (error: Error) => {
				console.log(error);
				reject(error);
			});
		});
	}

	updateProductsOrder(products: Array<Product>): Promise<any> {
		return new Promise((resolve, reject) => {
			const productsJson: Array<any> = new Array();
			if (products && products.length > 0) {
				products.forEach((p: Product, index) => {
					p.order = index + 1;
					productsJson.push(p.toReorderJson());
				});
			}
			this.requestService.putData(APP_CONFIG.WEBSERVICE.PRODUCTS_REORDER, productsJson).then((response: any) => {
				resolve(response);
			}, (error: Error) => {
				console.log(error);
				reject(error);
			});
		});
	}

	getListProductType(): Array<ProductRegisterType> {
		return [
			ProductRegisterType.APPETIZER,
			ProductRegisterType.MAIN_COURSE,
			ProductRegisterType.DRINKS,
			ProductRegisterType.DESSERTS,
			ProductRegisterType.OTHERS
		];
	}

	getListPriceType(): Array<ChargeOption> {
		return [
			ChargeOption.SUM_TOTAL,
			ChargeOption.HIGHEST_VALUE,
			ChargeOption.LOWER_VALUE,
			ChargeOption.AVERAGE
		];
	}

	/**
	 * COMPLEMENTS
	 * =====================================
	 */

	loadComplements(productId: number): Promise<Array<Complement>> {
		return new Promise((resolve, reject) => {
			const url: string = APP_CONFIG.WEBSERVICE.COMPLEMENTS + '?productId=' + productId;
			this.requestService.getData(url).then((response: any) => {
				resolve(response || []);
			}, (error: Error) => {
				console.log(error);
				reject(error);
			});
		});
	}

	saveComplement(complement: Complement): Promise<any> {
		return new Promise((resolve, reject) => {
			console.log(JSON.stringify(complement.toJson()));
			if (complement.id == null) {
				//INSERT
				this.requestService.postData(APP_CONFIG.WEBSERVICE.COMPLEMENTS, complement.toJson(), true).then((response: any) => {
					resolve(UtilHelper.getIdFromLocationPath(response.location));
				}, (error: Error) => {
					console.log(error);
					reject(error);
				});
			} else {
				//UPDATE
				this.requestService.putData(APP_CONFIG.WEBSERVICE.COMPLEMENTS, complement.toJson()).then((response: any) => {
					resolve(null);
				}, (error: Error) => {
					console.log(error);
					reject(error);
				});
			}
		});
	}

	duplicateComplement(complement: Complement): Promise<void> {
		return new Promise((resolve, reject) => {
			const data: any = {
				complementId: complement.id,
				productId: complement.productId
			};
			this.requestService.postData(APP_CONFIG.WEBSERVICE.COMPLEMENTS_DUPLICATE, data).then((response: any) => {
				resolve();
			}, (error: Error) => {
				console.log(error);
				reject(error);
			});
		});
	}

	deleteComplement(complementId: number): Promise<void> {
		return new Promise((resolve, reject) => {
			this.requestService.deleteData(APP_CONFIG.WEBSERVICE.COMPLEMENTS + "/" + complementId).then((response: any) => {
				resolve();
			}, (error: Error) => {
				console.log(error);
				reject(error);
			});
		});
	}

	updateComplementsOrder(complements: Array<Complement>): Promise<any> {
		return new Promise((resolve, reject) => {
			this.requestService.putData(APP_CONFIG.WEBSERVICE.COMPLEMENTS_REORDER, complements).then((response: any) => {
				resolve(response);
			}, (error: Error) => {
				console.log(error);
				reject(error);
			});
		});
	}

	/**
	 * COMPLEMENTS OPTIONS
	 * =====================================
	 */

	getComplementOptions(complementId: number): Promise<Array<ComplementOption>> {
		return new Promise((resolve, reject) => {
			const url: string = APP_CONFIG.WEBSERVICE.COMPLEMENT_OPTIONS + '?complementId=' + complementId;
			this.requestService.getData(url).then((response: any) => {
				const complementOptions: Array<ComplementOption> = new Array<ComplementOption>();
				if (response && response.length > 0) {
					response.forEach((co: any) => {
						complementOptions.push(new ComplementOption(co));
					});
				}
				resolve(complementOptions);
			}, (error: Error) => {
				console.log(error);
				reject(error);
			});
		});
	}

	saveComplementOption(complementOption: ComplementOption): Promise<any> {
		return new Promise((resolve, reject) => {
			if (complementOption.id == null) {
				//INSERT
				this.requestService.postData(APP_CONFIG.WEBSERVICE.COMPLEMENT_OPTIONS, complementOption.toJson(), true).then((response: any) => {
					resolve(UtilHelper.getIdFromLocationPath(response.location));
				}, (error: Error) => {
					console.log(error);
					reject(error);
				});
			} else {
				//UPDATE
				this.requestService.putData(APP_CONFIG.WEBSERVICE.COMPLEMENT_OPTIONS, complementOption.toJson()).then((response: any) => {
					resolve(null);
				}, (error: Error) => {
					console.log(error);
					reject(error);
				});
			}
		});
	}

	deleteComplementOption(complementOptionId: number): Promise<void> {
		return new Promise((resolve, reject) => {
			this.requestService.deleteData(APP_CONFIG.WEBSERVICE.COMPLEMENT_OPTIONS + "/" + complementOptionId).then((response: any) => {
				resolve();
			}, (error: Error) => {
				console.log(error);
				reject(error);
			});
		});
	}

	/**
	 * PRODUCT AVAILABILITY
	 * =====================================
	 */

	getProductAvailability(productId: number): Promise<Array<BusinessHour>> {
		return new Promise((resolve, reject) => {
			const urlRequest: string = this.requestService.buildUrlPathParams({ productId: productId }, APP_CONFIG.WEBSERVICE.GET_PRODUCT_AVAILIBILITY);
			this.requestService.getData(urlRequest).then((response: Array<BusinessHour>) => {
				console.log(response);
				resolve(response);
			}, (error: Error) => {
				console.log(error);
				reject(error);
			});
		});
	}

	saveProductAvailability(productId: number, establishmentId: number, isEstablishmentHours: boolean, productHours?: Array<BusinessHour>): Promise<any> {
		return new Promise((resolve, reject) => {
			const data: any = { };
			if (!isEstablishmentHours) {
				const productHoursJson: Array<any> = new Array();
				productHours.forEach((b: BusinessHour) => {
					if (b.selected) {
						productHoursJson.push(b.toJson());
					}
				});
				data.productHours = productHoursJson;
			}
			data.productId = productId;
			data.establishmentHours = isEstablishmentHours;
			data.establishmentId = establishmentId;

			console.log(JSON.stringify(data));
			this.requestService.postData(APP_CONFIG.WEBSERVICE.SAVE_PRODUCT_AVAILIBILITY, data).then((response: any) => {
				console.log(response);
				resolve(response);
			}, (error: Error) => {
				console.log(error);
				reject(error);
			});
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/category/products/product.service.ts